module.exports = __webpack_public_path__ + "static/media/signage-indoor-img63.6d46f94e.jpg";